module.exports = __webpack_public_path__ + "img/hermelin_logo.d613ae54.svg";